import React, { SetStateAction } from "react";
import { Range, getTrackBackground } from "react-range";
import { handleVolumeChange } from "@/utils/services/video";
import { YouTubePlayerRef } from "@/utils/types/youtube-player-ref-type";

interface RangeInputProps {
  volume: number;
  playerRef: YouTubePlayerRef;
  setVolume: (value: SetStateAction<number>) => void;
}

const RangeInput: React.FC<RangeInputProps> = ({
  volume,
  setVolume,
  playerRef,
}) => {
  const [values, setValues] = React.useState([volume]);
  return (
    <Range
      step={1}
      min={0}
      max={100}
      values={values}
      onChange={(values) => {
        setValues(values);
        handleVolumeChange(values[0], setVolume, playerRef);
      }}
      renderTrack={({ props, children }) => (
        <div
          onMouseDown={props.onMouseDown}
          onTouchStart={props.onTouchStart}
          style={{
            ...props.style,
            height: "36px",
            display: "flex",
            width: "100px",
          }}
        >
          <div
            ref={props.ref}
            style={{
              height: "5px",
              width: "100%",
              borderRadius: "4px",
              background: getTrackBackground({
                values: values,
                colors: ["#098898", "#C9E3E8"],
                min: 0,
                max: 100,
              }),
              alignSelf: "center",
            }}
          >
            {children}
          </div>
        </div>
      )}
      renderThumb={({ props, isDragged }) => (
        <div
          {...props}
          style={{
            ...props.style,
            height: "16px",
            width: "16px",
            borderRadius: "50%",
            backgroundColor: "#098898",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          className="transition-none"
        />
      )}
    />
  );
};

export default RangeInput;
